import React from 'react';
import ControlsMenuList from './controls_menu_list';
import ParticipantGroupList from './participant_group_list';

export default function ControlsMenu(props) {

  return (
  	<div className="abl-nav-menu" onMouseDown={props.onMouseDown} onClick={props.onClick}>
			<ControlsMenuList 
				items={props.menuItems}
				onChange={props.onMenuItemChange}
        onClearAllClick={props.onMenuClearAllClick}>
        <ParticipantGroupList 
          id="teachers"
          items={props.teacherGroups}
          onChange={props.onTeacherSelect}
          onSelectAll={props.onParticipantGroupSelect.bind(null, 'teacher')}
        />
        <ParticipantGroupList 
          id="cohorts"
          style={{display: 'none'}}
          items={props.cohortGroups}
          onChange={props.onCohortSelect}
          onSelectAll={props.onParticipantGroupSelect.bind(null, 'cohort')}
        />
      </ControlsMenuList>
  	</div>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/controls_menu.js
 **/